
import React, { useState, useContext, useEffect } from 'react';
import LoginScreen from '../components/LoginScreen';
import WorkerDashboard from '../components/WorkerDashboard';
import { RefactoredAdminDashboard } from '../components/admin/RefactoredAdminDashboard';
import { RefactoredSupervisorDashboard } from '../components/supervisor/RefactoredSupervisorDashboard';
import { RefactoredMonitorDashboard } from '../components/monitor/RefactoredMonitorDashboard';
import { User } from '../types';
import { apiService } from '../services/api';
import { RealTimeContext } from '../contexts/RealTimeContext';

const Index = () => {
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const realTimeContext = useContext(RealTimeContext);

  const handleLogin = async (user: User) => {
    setCurrentUser(user);
    // Set current user in API service for authentication
    apiService.setCurrentUser(user.id);
    
    // Connect to SignalR with user info
    if (realTimeContext && realTimeContext.connect) {
      try {
        console.log('Connecting to SignalR for user:', user.id, 'role:', user.role);
        await realTimeContext.connect(user.id.toString(), user.role);
      } catch (error) {
        console.error('Failed to connect to SignalR:', error);
        // Don't block login if SignalR fails
      }
    } else {
      console.warn('RealTimeContext not available - SignalR will not be connected');
    }
  };

  const handleLogout = async () => {
    // Disconnect from SignalR
    if (realTimeContext && realTimeContext.disconnect) {
      try {
        await realTimeContext.disconnect();
      } catch (error) {
        console.error('Failed to disconnect from SignalR:', error);
      }
    }
    
    // Clear user state
    setCurrentUser(null);
    
    // Clear API service user
    apiService.setCurrentUser(null);
    
    // Clear any cached data in localStorage/sessionStorage (but preserve work sessions)
    localStorage.clear();
    sessionStorage.clear();
    
    // Don't force page reload - let users log back in and continue work
    // window.location.reload(); // Removed - this was preventing session continuation
  };

  if (!currentUser) {
    return <LoginScreen onLogin={handleLogin} />;
  }

  switch (currentUser.role) {
    case 'admin':
      return <RefactoredAdminDashboard currentUser={currentUser} onLogout={handleLogout} />;
    case 'monitor':
      return <RefactoredMonitorDashboard currentUser={currentUser} onLogout={handleLogout} />;
    case 'supervisor':
      return <RefactoredSupervisorDashboard currentUser={currentUser} onLogout={handleLogout} />;
    case 'worker':
    default:
      return <WorkerDashboard user={currentUser} onLogout={handleLogout} />;
  }
};

export default Index;
